import { GET_FORM_DETAILS, GET_FORM_SETTINGS } from '@gameday/common/constants/endpoints'

export default {
  getFormSettings: GET_FORM_SETTINGS, // 'gamedayapi/forms/setting',
  getFormDetails: GET_FORM_DETAILS, // 'gamedayapi/forms/details',
}
